var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component"},'component',_vm.currentProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }